import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const SubFamiliaFormGroup = ({ fIsSubmitting }) => (
  <Form.Group>
    <Form.Label text='SUBFAMILIA' htmlFor='input-subFamilia' md={4} alignRightAt='md' />
    <Col md={8}>
      <Field name='subFamilia'>
        {({ field }) => <Form.InputText {...field} disabled={fIsSubmitting} id='input-subFamilia' />}
      </Field>
    </Col>
  </Form.Group>
)

export default React.memo(SubFamiliaFormGroup)
